export default function (start: number,end:number, multiplier: number) {
  return (1-multiplier)*start + multiplier*end;
}
